/** Recent activity under the bell: its words, and the store's entries shaped for ActivityList. */
import type { ActivityListEntry } from "../../components/molecules/ActivityList/ActivityList.types";
import { absoluteTime, KIND_SCREEN_READER_LABEL, relativeTime } from "./notifyFormat";
import type { ActivityView } from "./notify.types";

export const NOTIFICATION_ACTIVITY_COPY = {
  title: "Recent activity",
  clear: "Clear",
  newLabel: "New.",
  emptyTitle: "No notifications yet",
  emptyBody: "When something is saved, starts, finishes or needs a fix, it shows up here.",
  bell: (unread: number, hasError: boolean) =>
    unread ? `Notifications, ${unread} new${hasError ? ", including an error" : ""}` : "Notifications",
} as const;

export const toActivityEntries = (activity: ActivityView[], nowMs: number, locale?: string): ActivityListEntry[] =>
  activity.map((entry) => ({
    id: entry.id,
    kind: entry.kind,
    icon: entry.icon,
    kindLabel: KIND_SCREEN_READER_LABEL[entry.kind],
    title: entry.title,
    body: entry.body,
    timeLabel: relativeTime(entry.at, nowMs, locale),
    timeTitle: absoluteTime(entry.at, locale),
    dateTime: new Date(entry.at).toISOString(),
    isNew: entry.isNew,
    actionLabel: entry.action?.label ?? null,
  }));
